__turbopack_context__.v({
  "social": "SocialLinks-module-scss-module__j7G10q__social",
  "social-links": "SocialLinks-module-scss-module__j7G10q__social-links",
});
